<template>
  <div>
    <AddDiscount update @update="updateDiscount = !updateDiscount" :key="updateDiscount" />
    <Toast title="بروزرسانی با موفقیت انجام شد" :showToast="showToast" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import AddDiscount from '../../../components/dadban/discount/AddDiscount.vue'
import Toast from '../../../components/common/Toast.vue'
export default {
  page: {
    title: 'ویرایش کردن کد تخفیف',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-discount',
  data() {
    return {
      updateDiscount: false,
      showToast: false,
    }
  },
  watch: {
    updateDiscount() {
      this.updateToast()
    },
  },
  methods: {
    updateToast() {
      this.showToast = true
    },
  },
  components: {
    AddDiscount,
    Toast,
  },
}
</script>
